export enum NoticesActionTypes {
    FETCH_NOTICES = "FETCH_NOTICES"
}
